import styled from "styled-components";
import Modal from '@iso/components/Feedback/Modal';

export const DeleteSensorModal = styled(Modal)`
  .ant-btn{
    color: #0B2A1B;
    border-color:#0B2A1B;
  }  
  .ant-btn.ant-btn-primary,.ant-btn.ant-btn-primary:hover{
    background:#0B2A1B;
    color: #fff;
  }   
  
  .ant-btn:hover{
    color: #0B2A1B;
    border-color:#0B2A1B;
  }
`;

export const SensorStatsContainer = styled.div`
  margin-top: 16px;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;

  .sensor-type-section {
    &:not(:last-child) {
      margin-bottom: 16px;
    }
  }

  .sensor-type-header {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 12px;
    font-size: 14px;
    font-weight: 600;
    color: #0B2A1B;
    border-bottom: 1px solid #dee2e6;
    padding-bottom: 8px;

    .sensor-icon-wrapper {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      display: flex;
      justify-content: center;
      align-items: center;

      .sensor-type-icon {
        width: 20px;
        height: 20px;
        fill: currentColor;
      }
    }

    .sensor-type-name {
      text-align: center;
    }

    .sensor-icon-spacer {
      display: none;
    }
  }

  .stats-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
    
    &:last-child {
      margin-bottom: 0;
    }

    &.current-row {
      justify-content: center;
      margin-bottom: 12px;
    }

    &.detail-row {
      .stat-item {
        flex: 1;
      }
    }
  }

  .stat-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    
    &:not(:last-child):not(.current-item) {
      border-right: 1px solid #dee2e6;
      padding-right: 8px;
      margin-right: 8px;
    }

    &.current-item {
      min-width: 120px;
    }
  }

  .stat-label {
    font-size: 12px;
    color: #6c757d;
    margin-bottom: 2px;
    font-weight: 500;
  }

  .stat-value {
    font-size: 14px;
    font-weight: 600;
    color: #495057;
    
    &.current {
      color: #0B2A1B;
      font-size: 16px;
    }
  }

  .sensor-separator {
    height: 1px;
    background: #dee2e6;
    margin: 16px 0;
  }
`;